function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6007_8128)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_6007_8128)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.0774 10.5097C10.183 10.2739 10.2422 10.0131 10.2422 9.73853C10.2422 9.6036 10.2278 9.47201 10.2008 9.34499C10.0191 8.48936 9.25802 7.8454 8.3491 7.8454C7.30518 7.8454 6.45593 8.69465 6.45593 9.73853C6.45593 10.7824 7.30518 11.6317 8.3491 11.6317C8.714 11.6317 9.05496 11.5276 9.34434 11.3481L10.0974 12.0064C10.3087 11.6991 10.555 11.4177 10.8307 11.1682L10.0774 10.5097Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8339 5C18.567 5 17.5364 6.03068 17.5364 7.29759C17.5364 7.46135 17.5539 7.62107 17.5866 7.77522C17.6598 8.12001 17.8107 8.43618 18.0199 8.70511L16.5021 10.637C16.8203 10.8322 17.1139 11.0637 17.3771 11.3258L18.8951 9.39379C19.1819 9.52278 19.4995 9.59518 19.8339 9.59518C21.1008 9.59518 22.1315 8.5645 22.1315 7.29759C22.1315 6.03068 21.1008 5 19.8339 5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5373 20.2564L11.6266 18.8075C11.3042 18.619 11.0057 18.3939 10.7371 18.1375L9.64797 19.5861C9.37292 19.4694 9.07062 19.4048 8.75352 19.4048C7.48665 19.4048 6.45593 20.4355 6.45593 21.7024C6.45593 22.9693 7.48661 24 8.75349 24C10.0204 24 11.0511 22.9693 11.0511 21.7024C11.0511 21.5518 11.0361 21.4048 11.0083 21.2622C10.935 20.8863 10.77 20.5429 10.5373 20.2564Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0208 11.051C12.0108 11.051 10.3755 12.6863 10.3755 14.6963C10.3755 16.7062 12.0108 18.3415 14.0208 18.3415C16.0308 18.3415 17.666 16.7063 17.666 14.6963C17.666 12.6863 16.0308 11.051 14.0208 11.051Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.499 16.169C20.5962 16.169 19.7843 16.5643 19.2262 17.1905L18.3538 16.6634C18.1985 17.0042 18.004 17.3234 17.7764 17.6157L18.649 18.1428C18.5232 18.4763 18.4539 18.8372 18.4539 19.2141C18.4539 19.4137 18.4737 19.6086 18.5105 19.7976C18.7836 21.1984 20.0194 22.2592 21.499 22.2592C23.178 22.2592 24.5441 20.8932 24.5441 19.2141C24.5441 17.5351 23.1781 16.169 21.499 16.169Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6007_8128"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_6007_8128"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  transform: "translate(6 5)"
})));

function SvgSharingLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingLogs);
export default __webpack_public_path__ + "static/media/sharing_logs.a8250d27.svg";
export { ForwardRef as ReactComponent };